// For responsive devices
jQuery(document).ready(function($) {
    if(jQuery('.wp-block-navigation__submenu-icon').length > 0){
        jQuery('.wp-block-navigation__submenu-icon').on('click', function(){
            var submenu_icon = jQuery(this);
            setTimeout(function(){
                if(submenu_icon.attr('aria-expanded') === 'true'){
                    submenu_icon.parent().addClass('pgut-submenu__open');
                }
                else {
                    submenu_icon.parent().removeClass('pgut-submenu__open');
                }
            }, 100);
        });
    }

    initGallery();
});


var $lastWindowTop = 0;
jQuery(window).scroll(function(){
    $lastWindowTop = stickyHeader($lastWindowTop);
});

function stickyHeader($lastWindowTop)
{
    let $direction_up = false;
    var $windowTop = jQuery(window).scrollTop();
    if($windowTop < $lastWindowTop)
        $direction_up = true;

    if($windowTop > 400) {
        jQuery('header').addClass('pgut-is-sticky');

        if($direction_up) {
            jQuery('header').addClass('pgut-is-sticky__up');
        }
        else{
            jQuery('header').removeClass('pgut-is-sticky__up');
        }
    }
    else if($windowTop < 300) {
        jQuery('header').removeClass('pgut-is-sticky');
        jQuery('header').removeClass('pgut-is-sticky__up');
    }

    return $windowTop;
}

function addClassHoverCardClickable(){
    if(jQuery('.pgut-clickable').length > 0){
        // mouseup plutôt que click pour le clic roulette
        jQuery('.pgut-clickable')
        .mouseenter(function(e){
            let $button = jQuery(this).find('.pgut-button').eq(0);
            if( $button.length > 0 ){
                $button.addClass('pgut-button__hover');
            }
        })
        .mouseleave(function(e){
            let $button = jQuery(this).find('.pgut-button').eq(0);
            if( $button.length > 0 ){
                $button.removeClass('pgut-button__hover');
            }
        });
    }
}

function initGallery(){
    if(jQuery('.pgut-gallery').length > 0){
        if(jQuery('.pgut-gallery__image').length > 0){
            jQuery('.pgut-gallery__image').on('click', function(){
                jQuery('.pgut-gallery__image__selected').removeClass('.pgut-gallery__image__selected');
                jQuery(this).addClass('pgut-gallery__image__selected');

                var src = jQuery(this).attr('src');
                var caption = jQuery(this).attr('data-caption');

                jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__image').attr('src', src);
                jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__caption').text(caption);
                if( caption == "" )
                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__caption').hide();
                else
                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__caption').show();
            });

            jQuery('.pgut-gallery__arrow-prev').on('click', function(){
                var current_selected_img = jQuery('.pgut-gallery__image__selected');
                if(current_selected_img.prev().length > 0){
                    var offset = current_selected_img.prev().position();
                    var scroll_left = jQuery('.pgut-gallery__thumbnails').scrollLeft();

                    jQuery('.pgut-gallery__thumbnails').scrollLeft(offset.left + scroll_left);

                    current_selected_img.removeClass('pgut-gallery__image__selected');
                    current_selected_img.prev().addClass('pgut-gallery__image__selected');

                    var src = current_selected_img.prev().attr('src');
                    var caption = current_selected_img.prev().attr('data-caption');

                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__caption').text(caption);
                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__image').attr('src', src);

                    if( caption == "" )
                        jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__caption').hide();
                    else
                        jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__caption').show();
                }
            });

            jQuery('.pgut-gallery__arrow-next').on('click', function(){
                var current_selected_img = jQuery('.pgut-gallery__image__selected');
                if(current_selected_img.next().length > 0){
                    var offset = current_selected_img.next().position();
                    var scroll_left = jQuery('.pgut-gallery__thumbnails').scrollLeft();

                    jQuery('.pgut-gallery__thumbnails').scrollLeft(offset.left + scroll_left);

                    current_selected_img.removeClass('pgut-gallery__image__selected');
                    current_selected_img.next().addClass('pgut-gallery__image__selected');

                    var src = current_selected_img.next().attr('src');
                    var caption = current_selected_img.next().attr('data-caption');

                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__caption').text(caption);
                    jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__image').attr('src', src);

                    if( caption == "" )
                        jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__caption').hide();
                    else
                        jQuery(this).parents('.pgut-gallery').find('.pgut-gallery__zoomed__caption').show();
                }

            });
        }
    }
}